import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Footer from './Footer'
import Header from './Header'

/**
 * Reset scroll on navigation.
 *
 * A client-side router keeps the scroll position by default, which lands you
 * halfway down a fresh page. Links carrying a hash
 * (`/verwalten#mietverwaltung`) scroll to that element instead.
 *
 * Only `pathname` and `hash` are watched, so query-string changes - the
 * Insights category filter - leave the scroll position alone.
 */
function ScrollManager() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      // Wait for the target to exist after the route's first paint.
      const id = hash.slice(1)
      requestAnimationFrame(() => {
        const target = document.getElementById(id)
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' })
          return
        }
        window.scrollTo(0, 0)
      })
      return
    }

    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}

export default function Layout() {
  return (
    <>
      <a className="skip-link" href="#inhalt">
        Zum Inhalt springen
      </a>
      <ScrollManager />
      <Header />
      <main id="inhalt">
        <Outlet />
      </main>
      <Footer />
    </>
  )
}
